// src/components/StorageItem.jsx
import React from 'react';
import {Typography, Badge} from 'antd';

const {Text} = Typography;

const StorageItem = React.memo(({item, itemImage}) => {
    const isEmpty = !item;
    const blockIndex = item?.blockIndex;
    const stackCount = item?.stackCount;
    const productCount = item?.productCount; // ProductCount도 표시될 수 있으므로 포함
    const isLockedOrBubbled = item?.IsBlockState_AnyBox_AnyBubble_Lock;


    return (
        <div
            style={{
                width: 'calc(25% - 5px)', // 4칸씩 만들려면 100% / 4 = 25%에서 gap을 빼줍니다.
                aspectRatio: '1 / 1', // 정사각형 유지
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: isEmpty ? '#f9f9f9' : '#ffffff',
                boxSizing: 'border-box',
                fontSize: '10px',
                fontWeight: 'bold',
                color: '#666',
                textAlign: 'center',
                position: 'relative', // Badge 위치 조정을 위해
            }}
        >
            {isEmpty ? (
                <Text type="secondary" style={{fontSize: '10px'}}>Empty</Text>
            ) : (
                <>
                    {itemImage && (
                        <img
                            src={itemImage}
                            alt={`Block ${blockIndex}`}
                            style={{
                                width: '100%', // 셀 내부에 꽉 채우기
                                height: '100%',
                                objectFit: 'contain', // 이미지가 잘리지 않고 비율 유지
                                borderRadius: '4px',
                            }}
                        />
                    )}

                    <Text strong style={{fontSize: '12px', marginTop: '4px'}}>ID: {blockIndex}</Text>
                    {stackCount > 1 && ( // stackCount가 1보다 클 때만 표시
                        <Badge count={stackCount} style={{backgroundColor: '#52c41a'}} offset={[-5, 5]}/>
                    )}
                    {productCount > 0 && ( // productCount가 0보다 클 때만 표시
                        <Text type="secondary" style={{fontSize: '10px'}}>({productCount})</Text>
                    )}
                    {isLockedOrBubbled && <div style={{color: 'red', fontSize: '8px'}}>잠김</div>}
                </>
            )}
        </div>
    );
});

export default StorageItem;